import Layout from "hocs/layouts/Layout"
import { useEffect } from "react"
import ProfileView from "components/Users/ProfileView"
import { connect } from "react-redux"
import { useParams } from "react-router-dom"
import { get_profile } from "../../redux/actions/auth/auth"


function Profile({
    profile,
    get_profile,
}){

    const params = useParams()
    const slug = params.slug

    useEffect(()=>{
        get_profile(slug)
    }, [])

    return(
        <Layout>
            <ProfileView profile={profile&&profile}/>
        </Layout>
    )
}

const mapStateToProps=state=>({
    profile: state.auth.profile
})

export default connect(mapStateToProps,{
    get_profile
})(Profile)